import React, { SVGAttributes } from 'react';

function PurpleAngleLongRightSVG(props: SVGAttributes<SVGSVGElement>): JSX.Element {
  return (
    <svg width={824} height={172} viewBox='0 0 824 172' fill='none' {...props}>
      <path
        transform='rotate(-9.343 .299 136.21)'
        fill='url(#prefix__paint0_linear-03)'
        d='M.299 136.21h834.4v35.372H.299z'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear-03'
          x1={833.898}
          y1={154.277}
          x2={182.649}
          y2={176}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#8298FC' />
          <stop offset={1} stopColor='#8298FC' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PurpleAngleLongRightSVG;
